(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/setup-listener.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/setup-listener.js');
"use strict";


const _svs$components$selfs = svs.components.selfserviceCart,
  constants = _svs$components$selfs.constants,
  logger = _svs$components$selfs.logger;
const coreData = svs.core.data;
const setupListener = (src, callbacks) => {
  if (coreData.tenant === constants.TENANT_LB) {
    const messageEvent = _ref => {
      let data = _ref.data,
        origin = _ref.origin;
      if (src.indexOf(origin) !== 0) {
        return;
      }
      const fn = callbacks[data.name];
      if (fn) {
        fn(data.data);
      } else {
        logger.info("Receiving event not responding to", data);
      }
    };
    window.addEventListener('message', messageEvent);
    return () => {
      window.removeEventListener('message', messageEvent);
    };
  }
  return () => {};
};
setGlobal('svs.components.selfserviceCart.setupListener', setupListener);

 })(window);